// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyA29AOqJXQF-HtQaMKk1gcyk7d12uWTzuY',
    authDomain: 'plan-de-coupe.firebaseapp.com',
    databaseURL: 'https://plan-de-coupe.firebaseio.com',
    projectId: 'plan-de-coupe',
    storageBucket: 'plan-de-coupe.appspot.com',
    messagingSenderId: '484657477454',
    appId: '1:484657477454:web:a423634bd95b930bd7101f'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
